import React from 'react';

export const IconCheck = () => (
  <svg viewBox="0 0 12 9">
    <path
      d="M11.8 0.2C11.5333 -0.0666667 11.1333 -0.0666667 10.8667 0.2L4 7.06667L1.13333 4.2C0.866667 3.93333 0.466667 3.93333 0.2 4.2C-0.0666667 4.46667 -0.0666667 4.86667 0.2 5.13333L3.53333 8.46667C3.66667 8.6 3.8 8.66667 4 8.66667C4.2 8.66667 4.33333 8.6 4.46667 8.46667L11.8 1.13333C12.0667 0.866667 12.0667 0.466667 11.8 0.2Z"
      fill="currentColor"
    />
  </svg>
);
